import React from 'react';
import ReactDOM from 'react-dom';
import Section from './Section';

it('renders without crashing', () => {
  const div = document.createElement('div');
  ReactDOM.render(
    <Section id="My ID">
      <h1>Lorem ipsum</h1>
    </Section>, 
  div);
  ReactDOM.unmountComponentAtNode(div);
});



// WEBPACK FOOTER //
// ./src/common/Section.test..js